import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import MenuHorizontal from "../../layouts/MenuHorizontal";
import {
  Container,
  Grid,
  Icon,
  Divider,
  Button,
  Transition,
} from "semantic-ui-react";
import { find, search } from "../../../actions/partida";
import { Rodape } from "../../layouts/Rodape";
import Partida from "./Partida";

class Partidas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      errors: {},
    };
  }

  componentWillMount = async () => {
    if (this.props.match.params.stringBusca)
      this.setState({ stringBusca: this.props.match.params.stringBusca });
    await this.props.find(
      this.props.pagina,
      this.props.match.params.stringBusca
    );
    this.setState({ loading: false });
  };

  render() {
    const { partidas } = this.props;
    return (
      <div>
        <MenuHorizontal />
        <Container style={{ paddingTop: "10px" }}>
          <div style={{ textAlign: "center", marginBottom: "35px" }}>
            <Button
              className="ui-btn-1"
              as={Link}
              to={"/dashboard/partidas/cadastrar"}
            >
              <Icon name="plus" /> Adicionar Partida
            </Button>
            <Transition>
              <div>
                <div className="ui-div-msg">
                  <br />
                </div>
                <Link to="/dashboard" size="small">
                  Voltar
                </Link>
              </div>
            </Transition>
          </div>
          <Divider horizontal>Partidas</Divider>
          <Grid columns={4} doubling stackable style={{ marginTop: "20px" }}>
            {!!partidas.length &&
              partidas.map((partida) => (
                <Grid.Column key={partida._id}>
                  <Partida partida={partida} />
                </Grid.Column>
              ))}
          </Grid>
        </Container>
        <Rodape />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    partidas: state.partida.partidas ? state.partida.partidas : [],
    quantidadeBusca: state.partida.quantidadeBusca,
    quantidade: state.partida.quantidade,
    pagina: state.partida.pagina,
    error: state.partida.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      find,
      search,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Partidas);
